// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_js":"110ccad0b9d3fadc","node_modules_canvg_lib_index_es_js":"76daa9dea7b80f92","node_modules_html2pdf_js_node_modules_dompurify_dist_purify_es_mjs":"c9c50f10744b48db","src_app_account_account_module_ts":"3717845e62c3d202"}[chunkId] + ".js";
};